import { render, staticRenderFns } from "./TemplateCardMenu.vue?vue&type=template&id=54d46059&scoped=true&"
import script from "./TemplateCardMenu.vue?vue&type=script&lang=js&"
export * from "./TemplateCardMenu.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=54d46059&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d46059",
  null
  
)

export default component.exports